<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <el-button type="primary" size="medium" plain @click="back">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
              </div>
            </el-row>
          </div>
        </div>
        <div class="rowTipStyle" style="text-align: center;">
        </div>
        <div style="padding: 10px;">

          <div width="100%">
            <div style="text-align: center;font-size:20px;">表格预览</div>
            <img :src="imageSrc" style="width: 100%;height: 100%" />
          </div>

        </div>

      </el-col>
    </el-row>

    <!-- Form -->
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="指定表头范围" :visible.sync="selectColumnTitleDialogVisible"
      height="50%" width="70%">
      <el-form :model="form">
        <div>
          <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <div class="rowContentStyle" style="display: flex;align-items: center;">
              <div style="font-weight: bold;">表头是从第</div>
              <div>

                <el-input-number v-model="startNum" :min="1" label="" @change="setStartNum"></el-input-number>
                <span style="font-weight: bold;">行开始,到第</span>
                <el-input-number v-model="endNum" :min="1" label="" @change="setEndNum"></el-input-number>
                <span style="font-weight: bold;">行结束</span>
              </div>
            </div>

            <div class="rowContentStyle" style="display: flex;align-items: center;">
              <div style="font-weight: bold;">表头是从第</div>
              <div>

                <el-input-number v-model="startColumnNum" :min="1" label="" @change="setStartColumnNum">
                </el-input-number>
                <span style="font-weight: bold;">列开始,到第</span>

                <el-input-number v-model="endColumnNum" :min="2" label="" @change="setEndColumnNum"></el-input-number>
                <span style="font-weight: bold;">列结束</span>
              </div>
            </div>

            <div style="display: flex;justify-content: center;margin-bottom:10px;"><span
                style="color: red;">点击上面的"+"或者"-"号让您的表头全部显示在下面的预览窗口中</span></div>
          </div>

          <div>

            <!--            <div
              style="font-size: 16px;font-weight: bold;display: flex;margin-top: 10px;margin-bottom: 10px;justify-content: center;">
              <el-button type="primary" @click="previewHeaderImage">预览表头</el-button>
            </div> -->
          </div>
          <div style="text-align: center;font-size: 18px;font-weight: bold;"><el-button type="primary" @click="previewHeaderImage">预览表头</el-button></div>
          <div style="display: flex;justify-content: center;">
            <img :src="header_image_url" style="width: 100%;height: 100%;" />
          </div>
          <!--          <div v-if="showRange"
            style="font-size: 16px;font-weight: bold;display: flex;margin-top: 10px;margin-bottom: 10px;justify-content: center;">
            表头在Excel中的单元格范围:{{headRange}}
          </div> -->

        </div>

      </el-form>
      <div v-if="previewSuccess">
        <div style="text-align: center;font-size: 18px;font-weight: bold;margin-top: 10px;">以下导入的表格各列效果</div>
        <el-table ref="dataList" :data="[]" style="width: 100%" empty-text="这里将会是填表人填好的数据" border res
          :header-cell-style="{background:'#eef1f6',color:'#606266'}">
          <el-table-column header-align="center" resizable align="center" :key="header" :label="convertHeader(header.label)"
            v-for="(header) in previewTableData">
           <template slot="header" slot-scope="scope">
              <div class="columnTitleStyle">
                <div>{{convertHeader(header.prop)}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="previewHeaderImage">预览表头</el-button>
        <el-button type="primary" @click="nextPage" :disabled="!previewSuccess">下一步</el-button>
      </div>
    </el-dialog>

    <!--表格名称-->
    <el-dialog width="60%" :close-on-click-modal="false" title="输入表格名称" :visible.sync="inputFormNameDialogVisible">
      <div class="colStyle">
        <el-input v-model="form_name" placeholder="输入表格名称" style="100%"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="inputFormNameDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="confrimFormName()">导 入</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        active: 0,
        isCopyFormName: true,
        isCopyFormComment: false,

        startNum: 1,
        endNum: 2,

        startColumnNum: 1,
        endColumnNum: 2,

        headerPreviewData: [],
        form_titles: [],

        form_name: '',
        form_comment: '',

        options: [],
        column_inputed_value: '',
        selectColumnTitleDialogVisible: false,
        selectColumnNameDialogVisible: false,
        inputFormNameDialogVisible: false,

        username: '',
        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '', // 预览整条记录

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [], // 选中导入字段的实际名称
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        settingColumnVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        // 预览表格的相关数据
        previewColumnLables: [],
        previewTableData: [],

        data_type: ['文本', '数字', '日期', '日期及时间', '单选', '多选', '图片', '视频', '定位'],
        is_optional: ['必须填写', '可以填写'],
        column_types: [],
        selectedColumyType: '',
        currentColumnTitle: '',
        currentColumnDescription: '',
        currentColumnSample: '',
        showColumnSample: false,

        previewHeader: [],
        imageSrc: '',
        excel_src_name: '',
        default_image_url: '/form/images/default_header.png',
        header_image_url: '',
        excel_column_count: 1,
        showRange: false,

        headRange: '',
        previewSuccess: false,

        form_headers: [],
        header_count: 0

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      var timestr = new Date().getTime()
      this.imageSrc = this.$route.params.image_url + '?q=' + timestr
      this.excel_src_name = this.$route.params.excel_src_name
      this.endColumnNum = this.$route.params.excel_column_count
      this.header_image_url = this.default_image_url
      // this.loadData()
    },
    methods: {

      confrimFormName() {
        let that = this

        if (this.form_name === '') {
          this.$message.error('请输入表格名称')
          return
        }

        var requestUrl = '/form/web/_import_excel_template.jsp'
        // 开启loading

        let data = {
          username: that.username,
          form_name: that.form_name,
          form_headers: JSON.stringify(that.form_headers),
          header_count: that.header_count
        }

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.$message({
              duration: 5000,
              message: '导入成功！如需修改，请在微信中用多人填表修改！',
              type: 'success'
            })
            that.inputFormNameDialogVisible = false
            that.form_name = ''
            load.close()

            that.$router.push({
              path: '/form_list',
              params: {
                username: that.username
              }
            })
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      loadPreviewHeaderData() {
        let that = this

        this.headerPreviewData = []

        var requestUrl = '/form/web/_load_preview_header.jsp'
        // 开启loading

        let data = {
          start_row: that.startNum,
          end_row: that.endNum,
          username: that.username
        }

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.headerPreviewData = response.data.header_json_list
            that.form_titles = response.data.header_form_title
            that.endColumnNum = that.headerPreviewData.length
            that.previewHeader = that.headerPreviewData
            that.excel_column_count = response.data.excel_column_count

            load.close()
            that.$forceUpdate()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      setStartNum(value) {
        this.startNum = value
        if (this.startNum > this.endNum) {
          this.endNum = this.startNum
        }

        // this.loadPreviewHeaderData()
      },
      setEndNum(value) {
        this.endNum = value
        if (this.startNum > this.endNum) {
          this.startNum = this.endNum
        }

        // this.loadPreviewHeaderData()
      },
      setStartColumnNum(value) {
        this.startColumnNum = value
        if (this.startColumnNum === this.endColumnNum) {
          this.endColumnNum = this.startColumnNum + 1
        }

        // this.loadPreviewHeaderData()
        // this.previewHeader = this.headerPreviewData.slice(this.startColumnNum, this.endColumnNum)
        // this.$forceUpdate()
      },
      setEndColumnNum(value) {
        // if (value > this.headerPreviewData.length) {
        //   this.$message('已经到最后一列了哦~')
        //   return
        // }

        this.endColumnNum = value
        if (this.startColumnNum === this.endColumnNum) {
          this.startColumnNum = this.endColumnNum - 1
        }

        // this.loadPreviewHeaderData()
        // this.previewHeader = this.headerPreviewData.slice(this.startColumnNum, this.endColumnNum)
        // this.$forceUpdate()
      },
      initValues(index) {
        this.options = []
        var columnName = '第' + index + '列'
        for (var r = 0; r < this.tableData.length; r++) {
          // let cell = this.tableData[r][index]
          let row = this.tableData[r]
          var strValue = '' + row[columnName]

          if (strValue.trim() === '' || strValue.trim() === 'undefined') {
            continue
          }

          let option = {
            label: strValue,
            value: strValue
          }

          if (!this.hasPushInOptions(option)) {
            this.options.push(option)
          }
        }

        this.currentColumnTitle = ''
        this.column_inputed_value = ''
      },
      hasPushInOptions(tmpOption) {
        var pushed = false

        for (var i = 0; i < this.options.length; i++) {
          let o = this.options[i]
          if (o.label === tmpOption.label) {
            pushed = true
            break
          }
        }

        return pushed
      },
      selectBlur(e) {
        // this.column_inputed_value = e.target.value
      },
      selectColumnName() {
        // this.selectColumnTitleDialogVisible = false
        this.selectColumnNameDialogVisible = true
      },
      confrimSelectColumnName() {
        this.currentColumnTitle = this.column_inputed_value
        this.selectColumnNameDialogVisible = false
      },
      copy(data) {
        let url = data
        let oInput = document.createElement('input')
        oInput.value = url
        document.body.appendChild(oInput)
        oInput.select() // 选择对象
        document.execCommand('Copy') // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        })
        oInput.remove()
      },
      nextStep() {
        this.loadPreviewHeaderData()
        this.selectColumnTitleDialogVisible = true
      },
      nextPage() {
        // 导入开始
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_import_excel_header.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_src_name: that.excel_src_name,
              range: that.headRange
            }
          }).then(function(response) {
            console.log(response.data)

            var timestr = new Date().getTime()
            that.header_image_url = that.default_image_url + '?q=' + timestr

            that.selectColumnTitleDialogVisible = false
            that.inputFormNameDialogVisible = true

            that.form_headers = response.data.headers
            that.header_count = response.data.header_count

            that.previewTableData = response.data.preview_table

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      changeStatus(val, index) {
        console.log(val + index)
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },

      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      closeDialog() {
        this.showRange = false
        var timestr = new Date().getTime()
        this.header_image_url = this.default_image_url + '?q=' + timestr
        this.selectColumnTitleDialogVisible = false
        this.previewSuccess = false
      },
      previewHeaderImage() {
        var sCol = this.startColumnNum - 1
        var eCol = this.endColumnNum - 1
        var sRow = this.startNum
        var eRow = this.endNum

        var sColStr = String.fromCharCode(sCol + 65)
        var eColStr = String.fromCharCode(eCol + 65)

        var range = sColStr + sRow + ':' + eColStr + eRow
        this.headRange = range

        if (this.startNum > this.endNum) {
          this.$message.error('开始行号不能大于结束行号')
          return
        }

        if (this.startColumnNum > this.endColumnNum) {
          this.$message.error('开始列号不能大于结束列号')
          return
        }

        this.previewSuccess = false
        // this.$message(range)

        // console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_upload_excel_for_header.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_src_name: that.excel_src_name,
              range: range
            }
          }).then(function(response) {
            var timestr = new Date().getTime()
            that.header_image_url = response.data.header_image_url + '?q=' + timestr
            load.close()
            that.showRange = true
            that.previewSuccess = true

            that.loadPreviewHead()

            that.$message.success('预览成功！')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      loadPreviewHead() {
        // 导入开始
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_import_excel_header.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_src_name: that.excel_src_name,
              range: that.headRange
            }
          }).then(function(response) {
            that.form_headers = response.data.headers
            that.header_count = response.data.header_count

            that.previewTableData = response.data.preview_table

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      convertHeader(label) {
        if (label == null || label === 'null') {
          return ''
        } else {
          return label
        }
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/excel_preview.vue